import { api } from '@/lib/api';

interface User {
  id: string;
  email: string;
  auth_provider: string;
  created_at: string;
  updated_at: string;
}

interface AuthResponse {
  success: boolean;
  data: {
    user: User;
    accessToken: string;
    refreshToken: string;
  };
  message?: string;
}

interface UserResponse {
  success: boolean;
  data: User;
}

interface PasswordResetResponse {
  ok: boolean;
  data: null;
  message: string;
}

export const authService = {
  login: async (email: string, password: string): Promise<User> => {
    const response = await api.post<AuthResponse>('/auth/login', { email, password });
    return response.data.user;
  },

  register: async (email: string, password: string): Promise<User> => {
    const response = await api.post<AuthResponse>('/auth/register', { email, password });
    return response.data.user;
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await api.get<UserResponse>('/users/me');
    return response.data;
  },

  logout: async (): Promise<void> => {
    await api.post('/auth/logout');
  },

  forgotPassword: async (email: string): Promise<string> => {
    const response = await api.post<PasswordResetResponse>('/auth/forgot-password', { email });
    return response.message;
  },

  resetPassword: async (token: string, newPassword: string): Promise<string> => {
    const response = await api.post<PasswordResetResponse>('/auth/reset-password', { token, newPassword });
    return response.message;
  },
};

export type { User };
